import { Box, Grid2 as Grid, TextField, Typography } from '@mui/material';
import { RESERVES_AND_RESOURCES_FIELDS } from '../constants';
import { styles } from '../styles';
import type { DealDetailsFormField, DealDetailsFormValue, DealDetailsFormValues } from '../types';
import { FormSection } from './FormSection';

type ReservesSectionProps = {
  values: DealDetailsFormValues;
  onChange: (field: DealDetailsFormField, value: DealDetailsFormValue) => void;
  errors?: Record<string, boolean>;
};

export const ReservesSection = ({ values, onChange, errors = {} }: ReservesSectionProps) => {
  return (
    <FormSection title='Reserves & Resources'>
      <Grid size={12} spacing={2} container>
        {RESERVES_AND_RESOURCES_FIELDS.map(field => (
          <Grid size={{ sm: 12, md: 4 }} key={field.key}>
            <Box sx={{ mb: 1 }}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                {field.label}
              </Typography>
            </Box>
            <TextField
              sx={styles.textField}
              name={field.key}
              error={errors[field.key] || false}
              helperText={errors[field.key] ? 'Must be a number' : ''}
              value={values[field.key] || ''}
              onChange={event => onChange(field, event.target.value)}
              fullWidth
              slotProps={{
                input: {
                  endAdornment: (
                    <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>{field.unit}</Box>
                  ),
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </FormSection>
  );
};
